import { Box, Typography } from "@mui/material";
import loginImage from "../../assets/images/login-image.png";

const LeftSideImageText = () => {
  return (
    <>
      <Box
        component='img'
        src={loginImage}
        alt='Login'
        sx={{
          width: "140px",
          height: "auto",
          objectFit: "cover",
          mt: 2,
          ml: 4,
        }}
      />
      <Box sx={{ pl: 7 }}>
        <Typography variant='h5' sx={{ fontWeight: 700 }}>
          Welcome to the WHO Real-Time Reporting Tool
        </Typography>
        <Typography
          variant='h5'
          sx={{
            fontWeight: 300,
            fontStyle: "italic",
            fontSize: "16px",
            mt: 2,
            mb: 2,
          }}
        >
          AI-powered transcripts and summaries for governing body meetings.
        </Typography>
        <Box sx={{ fontSize: "16px" }}>
          Access transcripts and summarized meeting records powered by advanced
          artificial intelligence, with human review and oversight to ensure
          clarity, accountability, and transparency.
        </Box>
        <Typography variant='h6' sx={{ fontSize: "16px", mt: 2 }}>
          Log in with your WHO credentials to get started.
        </Typography>
      </Box>
    </>
  );
};

export default LeftSideImageText;
